import { createContext, useContext, useMemo } from 'react'

export const TcpaQuestionCustomContext = createContext(null)
export const useTcpaQuestionCustomContext = () => useContext(TcpaQuestionCustomContext)

export function TcpaContextProvider({ integrationData, extraFields, disabled, onChange, children }) {
  const tcpaquestioncustom = integrationData?.tcpaquestioncustom || {}

  const customField = useMemo(() => {
    const { cfid } = tcpaquestioncustom
    return (extraFields || [])
      .map(({ id, group, type, options, date_format, key: value }) => ({ id, group, type, options, date_format, value }))
      .find(f => f.value === cfid) || {}
  }, [extraFields, tcpaquestioncustom.cfid])

  const contextValue = {
    tcpaquestioncustom,
    customField,
    onChange,
    onAddAnswer: answer => {
      const answers = tcpaquestioncustom.answers || []
      answers.push(answer)
      onChange('answers', answers)
    },
    disabled,
  }

  return <TcpaQuestionCustomContext.Provider value={contextValue}>
    {children}
  </TcpaQuestionCustomContext.Provider>
}